import styled from 'styled-components'
import { colors, breakpoints, typo } from '../../styles/base/_allBase.styles'

export const GallerySection = styled.section`
  margin-top: 3rem;

  @media ${breakpoints.xxSmallDevices} {}
  @media ${breakpoints.xxSmallDevicesLandscape} {}
  @media ${breakpoints.extraSmallDevices} {}
  @media ${breakpoints.extraSmallDevicesLandscape} {}
  @media ${breakpoints.mediumDevices} {}
  @media ${breakpoints.mediumDevicesLandscape} {}
  @media ${breakpoints.largeDevices} {}
  @media ${breakpoints.extraLargeDevices} {}
  @media ${breakpoints.xxLargeDevices} {}
`

export const GalleryHeading = styled.h2`
  && {
    margin: 0 0 0.75rem;
    font-size: ${typo.h3_S};
    color: ${colors.warmPalette.primaryDark};
  }
`

export const GalleryHint = styled.p`
  && {
    margin: 0 0 1.5rem;
    font-size: ${typo.smallP_L};
    color: ${colors.neutralPalette.greyDark};
  }
`

export const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;

  @media ${breakpoints.xxSmallDevices} { grid-template-columns: 1fr; }
  @media ${breakpoints.xxSmallDevicesLandscape} {}
  @media ${breakpoints.extraSmallDevices} { grid-template-columns: 1fr; }
  @media ${breakpoints.extraSmallDevicesLandscape} {}
  @media ${breakpoints.mediumDevices} {}
  @media ${breakpoints.mediumDevicesLandscape} {}
  @media ${breakpoints.largeDevices} {}
  @media ${breakpoints.extraLargeDevices} {}
  @media ${breakpoints.xxLargeDevices} {}
`

export const PhotoFigure = styled.figure`
  min-width: 0;
  margin: 0;
`

export const PhotoCaption = styled.figcaption`
  && {
    margin: 0.8rem 0 0;
    font-size: ${typo.smallP_M};
    line-height: 1.5;
    color: ${colors.warmPalette.primaryDark};
  }
`

export const PhotoButton = styled.button`
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 4 / 5;
  padding: 0;
  border: 0;
  border-radius: 0.4rem;
  overflow: hidden;
  background: ${colors.coolPalette.neutralLight};
  cursor: zoom-in;

  img { object-fit: cover; }
  &:focus-visible {
    outline: 3px solid ${colors.warmPalette.primary};
    outline-offset: 4px;
  }
`

export const PhotoDialog = styled.dialog`
  box-sizing: border-box;
  width: min(1100px, calc(100% - 2rem));
  max-width: none;
  max-height: calc(100dvh - 2rem);
  margin: auto;
  padding: 1.5rem;
  border: 0;
  border-radius: 0.4rem;
  background: ${colors.neutralPalette.white};
  color: ${colors.neutralPalette.black};
  font-family: inherit;

  &::backdrop { background: ${colors.neutralPalette.black}e6; }
`

export const DialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  font-size: ${typo.smallP_L};
`

export const DialogImage = styled.div`
  position: relative;
  height: min(70dvh, 760px);
  img { object-fit: contain; }
`

export const DialogControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
  font-size: ${typo.smallP_M};
`

export const GalleryControl = styled.button`
  min-height: 44px;
  padding: 0.75rem 1rem;
  border: 1px solid ${colors.neutralPalette.greyLight};
  border-radius: 0.3rem;
  background: ${colors.neutralPalette.white};
  color: ${colors.warmPalette.primaryDark};
  font-family: inherit;
  font-size: ${typo.smallP_L};
  cursor: pointer;

  &:hover { background: ${colors.coolPalette.neutralLight}; }
  &:focus-visible {
    outline: 3px solid ${colors.warmPalette.primary};
    outline-offset: 2px;
  }
  &:disabled { opacity: 0.45; cursor: default; }
`
